import { render, staticRenderFns } from "./InstallationPane.vue?vue&type=template&id=9700216c"
import script from "./InstallationPane.vue?vue&type=script&lang=ts"
export * from "./InstallationPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports